export default function reconcileRedrivingTasks(cached: any[], fresh: any[], now: number, windowMs: number) {
    const previous = new Map((cached || []).map((task) => [task.fleet_execution_task_id, task]))
    return (fresh || []).map((task) => {
        const prior = previous.get(task.fleet_execution_task_id)
        const wasRedriving = prior?.status === 'Redriving'
        const stillStale = String(task.status).toLowerCase() === 'failed'
        const withinWindow = now - (prior?.redriving_since ?? 0) < windowMs
        if (wasRedriving && stillStale && withinWindow) {
            return { ...task, status: 'Redriving', redrivable: false, redriving_since: prior.redriving_since }
        }
        return task
    })
}
